import React, {useEffect, useState} from 'react'
import Multiselect from 'multiselect-react-dropdown';
import {optionsEdibleOils} from './Options';
import Sidebar from './Sidebar';
import { DateInput, StationInput, Val, ByProduct } from './Prices/SugarInput';
// import env from 'react-dotenv'

  export const EdibleOilsInputForm=()=>{
    const [date, setDate] = useState("")
    const [minimum, setMinimum] = useState()
    const [maximum, setMaximum] = useState()
    const [prodDetails, setProdDetails] = useState({})
    const [location, setLocation] = useState({});

    const handleSubmit =(e)=>{
        e.preventDefault();
        const input = {
        date: date,
        by_product : prodDetails[0].name,
        by_product_id:prodDetails[0].value,
        product :prodDetails[0].product,
        product_id :prodDetails[0].product_id,
        station: location[0].name,
         station_id: location[0].value,
        district :location[0].district,
        district_id :location[0].district_id,
        province:location[0].province,
        province_id: location[0].province,
        minimum: minimum, 
        maximum: maximum,

        }
          fetch(`${process.env.REACT_APP_API_URL}/crop-price/edible-oils-single`, {
          
            method: 'POST',
            headers: {
              "Content-Type" : "application/json"
            },
            body: JSON.stringify(input)
          }).then(() => {
           // console.log("New price record(s) added");    
           
          }).catch((err) => {
           // console.log("Unable to add record" + err);
          });
      }
    return(
        <>
        <div className="sidebar">
      <Sidebar/>
      </div>
      <div id="tabler">
        <h1>Edible Oils Form</h1>
      <DateInput x={setDate}></DateInput>
        <StationInput x={setLocation}></StationInput>
        <ByProduct x={setProdDetails} options={optionsEdibleOils} title={"Byproduct"}></ByProduct>
        <Val x={setMinimum} title={"Minimum"}></Val>
        <Val x={setMaximum} title={"Maximum"}></Val>
        <button type="button" class="btn submit-btn" onClick={handleSubmit}>Submit</button>
      </div>
        </>
    )
  }